import DevisSection from './DevisSection';

export default DevisSection;